import React from "react";
import FlashSaleComponent from "./FlashSaleComponent";
import OffersOfWeekComponent from "./OffersOfWeekComponent";
import SearchByBudgetComponent from "./SearchByBudgetComponent";

const FlashOfferSearch = () => {
  return (
    <div className="fluid-container mt-3 ml-5 mr-5">
      <div className="row">
        <div className="col-sm-4">
          <FlashSaleComponent />
        </div>
        <div className="col-sm-4">
          <OffersOfWeekComponent />
        </div>
        <div className="col-sm-4">
          <SearchByBudgetComponent />
        </div>
      </div>
    </div>
  );
};

export default FlashOfferSearch;
